import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useCurrency, Currency } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<Currency>
    useData={useCurrency}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
